import {createRouter, createWebHistory} from 'vue-router'
import swaggerPage from "@/SwaggerPage";
import swaggerPages from "@/SwaggerPages"
import pageNotFound from "@/PageNotFound";
import branchList from "@/BranchList.vue";
import index from "@/Index";

let paths = window.location.pathname.split('/')
let swagger_conf = paths[1] === 'branch' && paths[2]
    ? '/' + paths[1] + '/' + paths[2] + '/swagger_conf.json'
    : '/swagger_conf.json'
export async function createRouterFromJson() {
    let routes = []
    await fetch(swagger_conf)
        .then(r => r.json())
        .then(r => {
            r.routes
                .forEach(function (route) {
                    routes.push({
                        path: '/' + route.endpoint + '/',
                        component: swaggerPages,
                        children: route.parts.map(function (part) {
                            return {
                                path: part.endpoint,
                                component: swaggerPage,
                                props: {
                                    file: part.file
                                },
                            }
                        })
                    });
                    routes.push({
                        path: '/branch/:branch/' + route.endpoint + '/',
                        component: swaggerPages,
                        children: route.parts.map(function (part) {
                            return {
                                path: part.endpoint,
                                component: swaggerPage,
                                props: {
                                    file: part.file
                                },
                            }
                        })
                    })
                })
        })

    routes.push({path: '/:pathMatch(.*)*', component: pageNotFound})
    routes.push({path: '/branch/:branch/', component: index})
    routes.push({path: '/branch/', component: branchList})
    routes.push({path: '/', component: index})


    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes
    })

    return router
}
